import { useEffect } from 'react'
import { hasWindow } from '../utils'

import useRafState from './use-raf-state'

export interface State {
  x: number
  y: number
}

const useWindowScroll = (): State => {
  const isClient = !hasWindow()

  const [state, setState] = useRafState<State>({
    x: isClient ? window.pageXOffset : 0,
    y: isClient ? window.pageYOffset : 0,
  })

  useEffect(() => {
    const handler = () => {
      setState({
        x: window.pageXOffset,
        y: window.pageYOffset,
      })
    }

    window.addEventListener('scroll', handler, {
      capture: false,
      passive: true,
    })

    return () => {
      window.removeEventListener('scroll', handler)
    }
  }, [setState])

  return state
}

export default useWindowScroll
